import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { SmsMessageCard } from "./sms-message-card";
/** History tab: the list of SMS sent to the patient with live status. */
export function SmsHistoryTab(_ref) {
  var messages = _ref.messages,
    isLoading = _ref.isLoading,
    templateNameById = _ref.templateNameById,
    onRetry = _ref.onRetry,
    retryingId = _ref.retryingId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center py-8",
      role: "status"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      className: "h-5 w-5 animate-spin text-sds-brand-default"
    }), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, t("loading", {
      defaultValue: "Loading…"
    })));
  }
  if (!messages.length) {
    return /*#__PURE__*/React.createElement("p", {
      className: "py-8 text-center text-style-body-small text-sds-base-tertiary"
    }, t("sms.history.empty", {
      defaultValue: "No SMS sent to this patient yet."
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, messages.map(function (message) {
    return /*#__PURE__*/React.createElement(SmsMessageCard, {
      key: message.id,
      message: message,
      templateName: templateNameById[message.template_id] || t("sms.history.template_fallback", {
        defaultValue: "Template #{{id}}",
        id: message.template_id
      }),
      onRetry: onRetry,
      isRetrying: retryingId === message.id
    });
  }));
}